export const movies = 
[
    {
      "movieName": "The Rocky Horror Picture Show",
      "imageUrl": "assets/Movies/TheRockyHorrorPictureShow.jpg"
    },
    {
      "movieName": "The Quiet Girl",
      "imageUrl": "assets/Movies/theQuietGirl.jpg"
    },
    {
      "movieName": "The Picture of Dorian Gray",
      "imageUrl": "assets/Movies/ThePictureofDorianGray.jpg"
    },
    {
      "movieName": "Jurassic Park",
      "imageUrl": "assets/Movies/JurassicPark.jpg"
    },
    {
      "movieName": "House Of Gucci",
      "imageUrl": "assets/Movies/HouseOfGucci.jpg"
    },
    {
      "movieName": "The Wolf of Wall Street",
      "imageUrl": "assets/Movies/TheWolfofWallStreet.jpg"
    },
    {
      "movieName": "Titanic",
      "imageUrl": "assets/Movies/Titanic.jpg"
    },
    {
      "movieName": "Shutter Island",
      "imageUrl": "assets/Movies/ShutterIsland.jpg"
    },
    {
      "movieName": "Guardians of The Galaxy",
      "imageUrl": "assets/Movies/GuardiansofTheGalaxy.jpg"
    },
    {
      "movieName": "Empire Strikes Back",
      "imageUrl": "assets/Movies/EmpireStrikesBack.jpg"
    },
    {
      "movieName": "Dora & The Lost City Of Gold",
      "imageUrl": "assets/Movies/DoraandTheLostCityOfGold.jpg"
    },
    {
      "movieName": "Harry Potter",
      "imageUrl": "assets/Movies/HarryPotter.jpg"
    },
    {
      "movieName": "Jaws",
      "imageUrl": "assets/Movies/Jaws.jpg"
    },
    {
      "movieName": "Avengers Infinity War",
      "imageUrl": "assets/Movies/AvengersInfinityWar.jpg"
    },
    {
      "movieName": "John Wick",
      "imageUrl": "assets/Movies/JohnWick.jpg"
    },
    {
      "movieName": "Beauty & The Beast",
      "imageUrl": "assets/Movies/BeautyAndTheBeast.jpg"
    },
    {
      "movieName": "Replicas",
      "imageUrl": "assets/Movies/Replicas.jpg"
    },
    {
      "movieName": "Joker",
      "imageUrl": "assets/Movies/Joker.jpg"
    },
    {
      "movieName": "Casino",
      "imageUrl": "assets/Movies/Casino.jpg"
    },
    {
      "movieName": "SuperBad",
      "imageUrl": "assets/Movies/SuperBad.jpg"
    }
  ]